export enum LocationTypeEnum {
    COUNTRY = 405,
    PROVINCE = 406,
    BREEDING_LOCATION = 410,
    SEED_STORAGE_LOCATION = 1500
}
